import { Role } from 'src/Enum/Report';
import { IGoalsAndOperationalPlansFormValues } from '../GoalAndOperationalPlansFormProvider/types';

export const mapToGoalsAndOperationPlansPayload = (
  formValues: IGoalsAndOperationalPlansFormValues
) => {
  const otherDescriptions = (formValues.otherDescriptions ?? []).map(
    (desc) => ({
      id: desc?.id,
      titleTh: desc?.titleTh ?? null,
      titleEn: desc?.titleEn ?? null,
      descriptionTh: desc?.descriptionTh ?? null,
      descriptionEn: desc?.descriptionEn ?? null,
    })
  );

  const introduction =
    formValues.overview?.introduction?.descriptionTh ||
    formValues.overview?.introduction?.descriptionEn
      ? {
          descriptionTh:
            formValues.overview?.introduction?.descriptionTh ?? null,
          descriptionEn:
            formValues.overview?.introduction?.descriptionEn ?? null,
        }
      : null;

  const remark =
    formValues.overview?.remark?.descriptionTh ||
    formValues.overview?.remark?.descriptionEn
      ? {
          descriptionTh: formValues.overview?.remark?.descriptionTh ?? null,
          descriptionEn: formValues.overview?.remark?.descriptionEn ?? null,
        }
      : null;

  const companyValueIncreasePlanIntroduction =
    formValues.companyValueIncreasePlans?.introduction?.descriptionTh ||
    formValues.companyValueIncreasePlans?.introduction?.descriptionEn
      ? {
          descriptionTh:
            formValues.companyValueIncreasePlans?.introduction?.descriptionTh ??
            null,
          descriptionEn:
            formValues.companyValueIncreasePlans?.introduction?.descriptionEn ??
            null,
        }
      : null;

  const companyValueIncreasePlanRemark =
    formValues.companyValueIncreasePlans?.remark?.descriptionTh ||
    formValues.companyValueIncreasePlans?.remark?.descriptionEn
      ? {
          descriptionTh:
            formValues.companyValueIncreasePlans?.remark?.descriptionTh ?? null,
          descriptionEn:
            formValues.companyValueIncreasePlans?.remark?.descriptionEn ?? null,
        }
      : null;

  const companyValueIncreasePlans = (
    formValues.companyValueIncreasePlans?.valueUpPlans ?? []
  ).map((plan) => ({
    ...plan,
    operationPlans: plan.goals ?? null,
    descriptionTh: plan.significanceTh ?? null,
    descriptionEn: plan.significanceEn ?? null,
    assets: (plan.assets ?? []).map((asset) => ({
      id: asset?.id ?? null,
      ...asset,
    })),
    relateGoals: (plan.relateGoals ?? []).map((relateGoal) => ({
      infoCategoryMasterDataId: relateGoal.infoCategoryMasterDataId ?? null,
      nameTh: relateGoal.nameTh ?? null,
      nameEn: relateGoal.nameEn ?? null,
    })),
    riskManagement: {
      ...plan.riskManagement,
      introduction:
        plan.riskManagement.introduction?.descriptionTh ||
        plan.riskManagement.introduction?.descriptionEn
          ? {
              descriptionTh:
                plan.riskManagement.introduction?.descriptionTh ?? null,
              descriptionEn:
                plan.riskManagement.introduction?.descriptionEn ?? null,
            }
          : null,
      remark:
        plan.riskManagement.remark?.descriptionTh ||
        plan.riskManagement.remark?.descriptionEn
          ? {
              descriptionTh: plan.riskManagement.remark?.descriptionTh ?? null,
              descriptionEn: plan.riskManagement.remark?.descriptionEn ?? null,
            }
          : null,
    },
  }));
  const completedSection = {
    id: formValues.completedSection?.id ?? null,
    isCompletedTh: formValues.completedSection?.isCompletedTh ?? false,
    isCompletedEn: formValues.completedSection?.isCompletedEn ?? false,
    roleStampTh: formValues.completedSection?.roleStampTh ?? Role.NONE,
    roleStampEn: formValues.completedSection?.roleStampEn ?? Role.NONE,
    dateTh: formValues.completedSection?.dateTh ?? undefined,
    dateEn: formValues.completedSection?.dateEn ?? undefined,
  };

  const updatedCompanyValueIncreasePlans = {
    ...formValues.companyValueIncreasePlans,
    introduction: companyValueIncreasePlanIntroduction,
    remark: companyValueIncreasePlanRemark,
    goals: companyValueIncreasePlans,
  };
  return {
    overview: {
      introduction,
      remark,
    },
    otherDescriptions: otherDescriptions,
    companyValueIncreasePlans: updatedCompanyValueIncreasePlans,
    completedSection,
  };
};
